<template>
    <div>
        <div>
            <b-row no-gutters>
                <b-col>
                    <StoreNav></StoreNav>
                </b-col>
            </b-row>
        </div>
        <EmployeeTabContent></EmployeeTabContent>
    </div>
</template>

<script>
import StoreNav from "./StoreNav.vue";
import EmployeeTabContent from "./EmployeeTabContent.vue";

export default {
    name: "employee",
    components: {
        StoreNav,
        EmployeeTabContent
    }
};
</script>
<style lang="scss">
</style>
